import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';

export type DeleteProcedureTemplateRequest = { ids: string[] };

async function deleteProcedureTemplates(req: DeleteProcedureTemplateRequest): Promise<void> {
    const { data } = await api.delete(`/procedures/templates`, { data: req });
    return data;
}

export function useDeleteProcedureTemplates(): UseMutationResult<void, unknown, DeleteProcedureTemplateRequest, unknown> {
    return useMutation(deleteProcedureTemplates, {
        onSettled: () => {
            queryClient.invalidateQueries(['procedures-templates']);
            queryClient.invalidateQueries(['firm']);
        },
    });
}
